import styled from "styled-components";
import { PageContainer } from "../../assets/styles/GlobalStyles";

export const Container = styled(PageContainer)`
  background-color: #fff;
`;
